var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGreenBar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 93,
    height: 50,
    viewBox: "0 0 93 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.832031,
    y: 5,
    width: 4,
    height: 45,
    fill: "#97B644"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8.83203,
    y: 20,
    width: 4,
    height: 30,
    fill: "#97B644"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 16.832,
    y: 10,
    width: 4,
    height: 40,
    fill: "#97B644"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 24.832,
    y: 20,
    width: 4,
    height: 30,
    fill: "#97B644"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 32.832,
    width: 4,
    height: 50,
    fill: "#97B644"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 40.832,
    y: 20,
    width: 4,
    height: 30,
    fill: "#97B644"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 48.832,
    y: 20,
    width: 4,
    height: 30,
    fill: "#97B644"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 56.832,
    y: 15,
    width: 4,
    height: 35,
    fill: "#97B644"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 64.832,
    y: 25,
    width: 4,
    height: 25,
    fill: "#97B644"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 72.832,
    y: 10,
    width: 4,
    height: 40,
    fill: "#97B644"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 80.832,
    y: 20,
    width: 4,
    height: 30,
    fill: "#97B644"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 88.832,
    y: 15,
    width: 4,
    height: 35,
    fill: "#97B644"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 8.83203,
    y: 16.5293,
    width: 4,
    height: 2,
    fill: "#154154"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 16.832,
    y: 6.97961,
    width: 4,
    height: 2,
    fill: "#154154"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 24.832,
    y: 17.0282,
    width: 4,
    height: 2,
    fill: "#154154"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 40.832,
    y: 16.5293,
    width: 4,
    height: 2,
    fill: "#154154"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 48.832,
    y: 16.5293,
    width: 4,
    height: 2,
    fill: "#154154"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 56.832,
    y: 11.313,
    width: 4,
    height: 2,
    fill: "#154154"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 64.832,
    y: 21.9419,
    width: 4,
    height: 2,
    fill: "#154154"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 72.832,
    y: 6.97961,
    width: 4,
    height: 2,
    fill: "#154154"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 80.832,
    y: 17.0282,
    width: 4,
    height: 2,
    fill: "#154154"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 88.832,
    y: 11.313,
    width: 4,
    height: 2,
    fill: "#154154"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenBar);
export default __webpack_public_path__ + "static/media/green-bar.61203354d02d4078a4ee86253eb5ba9a.svg";
export { ForwardRef as ReactComponent };